import { css, keyframes } from '@emotion/react';
import cns from 'classnames';
import { BaseHTMLAttributes, FC } from 'react';
import { MapUiSize, MAPUI_SIZES } from '../../common/types';

export const LOADING_SPINNER_CLASSNAME = '__mapui_loading_spinner';

export const LOADING_SPINNER_SIZE = MAPUI_SIZES;

export interface LoadingSpinnerProps
  extends BaseHTMLAttributes<HTMLDivElement> {
  color?: string;
  size?: MapUiSize;
  className?: string;
}

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const applyMainStyles =
  ({ color, size }: Pick<LoadingSpinnerProps, 'color' | 'size'>) =>
  (theme) => {
    const spinnerCss = css({
      ...theme.loadingSpinner.defaultStyles,
    });
    const sizeCss = css(theme.loadingSpinner[size]);
    const finalColor = theme.colors[color] || color;
    const componentCss = css({
      borderColor: `${finalColor} ${finalColor} transparent transparent`,
      animation: `${rotate} 0.5s linear 0s infinite normal`,
    });
    return css(spinnerCss, sizeCss, componentCss);
  };

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  color = 'interaction200',
  size = 'md',
  className = '',
  ...rest
}: LoadingSpinnerProps) => (
  <div
    className={cns(LOADING_SPINNER_CLASSNAME, className)}
    css={applyMainStyles({ color, size })}
    role="progressbar"
    aria-valuetext="Loading…"
    aria-busy="true"
    {...rest}
  />
);
